import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { flushSync } from "react-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";
import CompassLayout from "@/components/compass/CompassLayout";
import { useCompass } from "@/context/CompassContext";
import { COUNTRY_FLAGS } from "@/data/compass";

export default function CompassCity() {
  const nav = useNavigate();
  const { draft, update } = useCompass();
  const [geo, setGeo] = useState({});
  const [loading, setLoading] = useState(true);
  const [pickedState, setPickedState] = useState(null);

  useEffect(() => {
    if (!draft.country) { nav("/brujula/pais", { replace: true }); return; }
    api.get("/compass/geo")
      .then((r) => setGeo(r.data.geo || {}))
      .catch(() => toast.error("No se pudo cargar la información local"))
      .finally(() => setLoading(false));
  }, [draft.country, nav]);

  const states = geo[draft.country] || [];
  const cities = pickedState ? (states.find((s) => s.state === pickedState)?.cities || []) : [];

  const chooseState = (s) => { setPickedState(s.state); update({ state: s.state, city: null }); };
  const chooseCity = (c) => {
    flushSync(() => update({ city: c }));
    nav(draft.path === "idea" ? "/brujula/idea" : "/brujula/negocio");
  };

  return (
    <CompassLayout back="/brujula/pais" step={2} total={4} testid="page-compass-city">
      <div className="mb-5">
        <div className="label-mono text-muted-foreground">Paso 2 de 4</div>
        <h1 className="display text-3xl md:text-4xl mt-2 leading-[1]">
          <span className="mr-2">{COUNTRY_FLAGS[draft.country] || ""}</span>{draft.country}
        </h1>
        <p className="mt-2 text-sm text-muted-foreground">
          Elige tu estado o provincia, luego tu ciudad.
        </p>
      </div>

      {loading && <div className="text-sm text-muted-foreground">Cargando…</div>}

      <div className="mb-6">
        <div className="label-mono mb-2 text-muted-foreground">Estado / Provincia</div>
        <div className="grid grid-cols-2 gap-3">
          {states.map((s) => (
            <button
              key={s.state}
              onClick={() => chooseState(s)}
              data-testid={`state-${s.state.replace(/\s+/g, "-").toLowerCase()}`}
              className={`border-2 border-foreground p-3 text-left transition-colors ${
                pickedState === s.state ? "bg-foreground text-background" : "bg-surface hover:bg-muted"
              }`}
            >
              <div className="font-semibold text-sm">{s.state}</div>
              <div className="text-xs opacity-70 mt-0.5">{s.cities.length} ciudad{s.cities.length !== 1 ? "es" : ""}</div>
            </button>
          ))}
        </div>
      </div>

      {pickedState && (
        <div>
          <div className="label-mono mb-2 text-muted-foreground">Ciudad</div>
          <div className="flex flex-col gap-2">
            {cities.map((c) => (
              <button
                key={c}
                onClick={() => chooseCity(c)}
                data-testid={`city-${c.replace(/\s+/g, "-").toLowerCase()}`}
                className="border-2 border-foreground p-4 bg-surface text-left font-semibold hover:bg-foreground hover:text-background transition-colors shadow-[2px_2px_0_0_hsl(var(--foreground))]"
              >
                {c}
              </button>
            ))}
          </div>
        </div>
      )}
    </CompassLayout>
  );
}
